<style lang="scss" scoped>
  .sub-header{
    background: #fff;
    display: flex;
    align-items: center;
    margin: -14px -14px 15px;
    height: 50px;
    border-bottom: 1px solid #e0e5e8;
    .start-icon{
      height: 16px;
      width: 3px;
      background: $color-primary;
      margin-left: 20px;
    }
    .title{
      font-size: 16px;
      margin-left: 10px;
    }
  }
</style>

<template>
  <div class="sub-header">
    <i class="start-icon" />
    <span class="title">{{ title }}</span>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {}
  }
}
</script>
